module.exports = __webpack_public_path__ + "static/media/security_2.c1a73263.png";